import { PlatformSlug } from 'constants/consts'
import { RewardTypeEnum } from '__generatedTypes__/globalTypes'
import { isRewardHidden } from 'pagesNew/Users/Edit/components/Items/useItems'

export const MAP_ENUM_TO_TITLE = {
  [RewardTypeEnum.PauseToken]: 'Pause Token',
  [RewardTypeEnum.FreeMissedStreak]: 'Free Missed Streak',
  [RewardTypeEnum.PrizeSelector]: 'Prize Selector',
  [RewardTypeEnum.Extension]: 'Extension',
  [RewardTypeEnum.MysteryBox]: 'Mystery Box',
}

const EXCLUDED_REWARD_TYPES = [RewardTypeEnum.MysteryBox]

export const REWARD_TYPE_OPTIONS = Object.keys(RewardTypeEnum)
  .filter((r) => !EXCLUDED_REWARD_TYPES.includes(r as RewardTypeEnum))
  .map((key) => ({
    id: key,
    title: MAP_ENUM_TO_TITLE[key as RewardTypeEnum],
  }))

export const getRewardTypeOptions = (platform: PlatformSlug) =>
  REWARD_TYPE_OPTIONS.filter((r) => !isRewardHidden(r.id as RewardTypeEnum, platform))
